<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">
                  <div class="card-header">
                    <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                    &nbsp;&nbsp;&nbsp;
                    <h6 class="card-title mb-0 float-start" style="padding-left: 25px">
                      {{ $t("ratebaseEdit") }}
                    </h6>
                     
                  </div>
  
                  <div class="card-body">
                   
                    <form
                      class="forms-sample"
                      @submit.prevent="submitData"
                      method="POST"
                    >                    
  

                    <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('rateBaseName_txt')
                          }}</label>
                        </div>

                        <div class="col-lg-8">
                          
                            <input
                            type="text"
                            class="form-control"
                            id="rateBaseName"
                            :placeholder="$t('rateBaseName_txt')"
                            v-model="forms.rateBaseName"
                            required
                          />
  
  
  
                          <div v-if="errors.rateBaseName">
                            <div
                              v-for="error in errors.rateBaseName"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                              $t('rateBaseDesc_txt')
                            }}</label>
                          </div>
                          <div class="col-lg-8">
                            <input
                              type="text"
                              class="form-control"
                              id="rateBaseDesc"
                              :placeholder="$t('rateBaseDesc_txt')"
                              v-model="forms.rateBaseDesc"
                              required
                            />
                            <div v-if="errors.rateBaseDesc">
                              <div
                                v-for="error in errors.rateBaseDesc"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>
                        
                      
                      
                      
                      
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('chargeCategory_txt')
                          }}</label>
                        </div>
                        <div class="col-lg-8">

                          <v-select
                              :options="fetchchargeCategory"
                              v-model="chargeCategory"
                              label="codeDesc"
                              return-object
                              @search="asyncSearchchargeCategory"
                              @input="changechargeCategory"
                          >
                              <template slot="option" slot-scope="option">
                                  {{ option.warehouseId }} - {{ option.customerId }} - {{ option.category }} - {{ option.codeId }} - {{ option.activeFlag }} - {{ option.codeDesc }}
                              </template>      
                          </v-select>

                          <div v-if="errors.chargeCategory">
                            <div
                              v-for="error in errors.chargeCategory"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="chargeType" class="col-form-label" style="padding-left: 25px">{{
                            $t('chargeType_txt')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                       
                          <v-select
                              :options="fetchchargeType"
                              v-model="chargeType"
                              label="codeDesc"
                              return-object
                              @search="asyncSearchchargeType"
                              @input="changechargeType"
                          >
                              <template slot="option" slot-scope="option">
                                  {{ option.warehouseId }} - {{ option.customerId }} - {{ option.category }} - {{ option.codeId }} - {{ option.activeFlag }} - {{ option.codeDesc }}
                              </template>      
                          </v-select>
                       
                          <div v-if="errors.chargeType">
                            <div
                              v-for="error in errors.chargeType"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
  
  
                       <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('SAPMaterialCode')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                        
                        
                          <v-select
                              :options="fetchSAPMaterialCode"
                              v-model="SAPMaterialCode"
                              label="codeDesc"
                              return-object
                              @search="asyncSearchSAPMaterialCode"
                              @input="changeSAPMaterialCode"
                          >
                              <template slot="option" slot-scope="option">
                                  {{ option.warehouseId }} - {{ option.customerId }} - {{ option.category }} - {{ option.codeId }} - {{ option.activeFlag }} - {{ option.codeDesc }}
                              </template>      
                          </v-select>

                          <div v-if="errors.SAPMaterialCode">
                            <div
                              v-for="error in errors.SAPMaterialCode"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
  
  
                      
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('SAPDivision')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="SAPDivision"
                            :placeholder="$t('SAPDivision')"
                            v-model="forms.SAPDivision"
                          />
                          <div v-if="errors.SAPDivision">
                            <div
                              v-for="error in errors.SAPDivision"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
  
  
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('uom')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                      
                          <v-select
                              :options="fetchUom"
                              v-model="Uom"
                              label="codeDesc"
                              return-object
                              @search="asyncSearchUom"
                              @input="changeUom"
                          >
                              <template slot="option" slot-scope="option">
                                  {{ option.warehouseId }} - {{ option.customerId }} - {{ option.category }} - {{ option.codeId }} - {{ option.activeFlag }} - {{ option.codeDesc }}
                              </template>      
                          </v-select>
                      
                          <div v-if="errors.uom">
                            <div
                              v-for="error in errors.uom"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
  
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="locCategory" class="col-form-label" style="padding-left: 25px">{{
                            $t('locCategory')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                      
                          <v-select
                              :options="fetchlocCategory"
                              v-model="locCategory"
                              label="codeDesc"
                              return-object
                              @search="asyncSearchlocCategory"
                              @input="changelocCategory"
                          >
                              <template slot="option" slot-scope="option">
                                  {{ option.warehouseId }} - {{ option.customerId }} - {{ option.category }} - {{ option.codeId }} - {{ option.activeFlag }} - {{ option.codeDesc }}
                              </template>      
                          </v-select>
                      
                          <div v-if="errors.locCategory">
                            <div
                              v-for="error in errors.locCategory"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                        
  
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="locCategory" class="col-form-label" style="padding-left: 25px">{{
                            $t('itemCategory')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                      
                          <v-select
                              :options="fetchitemCategory"
                              v-model="forms.itemCategory"
                              return-object
                          >
                          </v-select>
                      
                          <div v-if="errors.itemCategory">
                            <div
                              v-for="error in errors.itemCategory"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                        
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('query')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea
                            class="form-control"
                            id="query"
                            :placeholder="$t('query')"
                            v-model="forms.queryFormula"
                            rows="10"
                            max-rows="20"
                            ></textarea>
                           
                          <div v-if="errors.queryFormula">
                            <div
                              v-for="error in errors.queryFormula"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('statusTxt')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                             <v-select
                              :options="['ACTIVE','NOT ACTIVE']"
                              v-model="forms.status"
                          >
                          </v-select>
                           
                          <div v-if="errors.status">
                            <div
                              v-for="error in errors.status"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                        
                      
                      
  
                      <div class="card-footer">
                        <button
                          class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="backForm"
                          type="button"
                        >
                          <i class="link-icon" data-feather="arrow-left"></i>
                          {{ $t("backMess") }}
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <button class="btn btn-primary float-end btn-sm" type="submit">
                             <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
</template>
  
  
<script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  
  export default {
    name: "CmlRatebaseEdit",
    props: {},
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
    },
    data() {
      return {
        fetchitemCategory:['X','W'],
        fetchlocCategory:[],
        locCategory:null,
        fetchUom:[],
        Uom:null,
        fetchSAPMaterialCode:[],
        SAPMaterialCode:null,
        fetchchargeCategory:[],
        chargeCategory:null,
        fetchchargeType:[],
        chargeType:null,
        company_type:"",
        permision_role:[],
        isLoading: false,
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        errors: [],
        company_group:"",
        forms: { idRateBase: "", rateBaseName: "" , chargeCategory:"", chargeCategoryCode:"", chargeType:"", chargeTypeCode:"", SAPMaterialCode:"", SAPDivision:"", queryFormula:"", uom:"", addwho:"", rateBaseDesc:"", editwho:"",  adddate:"", editdate:"", rateBaseCode:"" , itemCategory:"", locCategory:"",locCategoryCode:""},
        userData: "",
        userRole: "",
      };
    },
    watch: {},
    methods: {

      asyncSearchlocCategory(ev){
          const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/bm-wms-code-cml/get-data";
          return this.$http
          .get(
              baseURI +
              `?limit=20&page=1&&codeType=LOC_CAT&codeDesc=${ev}`,
              { timeout: 60000 })
          .then((response) => {
              this.fetchlocCategory = response.data.datas.data;
          });
      },


      changelocCategory(ev){
          this.forms.locCategory      = ev.codeDesc          
          this.forms.locCategoryCode  = ev.codeId          
      },
      asyncSearchUom(ev){
          const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/bm-wms-code-cml/get-data";
          return this.$http
          .get(
              baseURI +
              `?limit=20&page=1&&codeType=RAT_BAS&codeDesc=${ev}`,
              { timeout: 60000 })
          .then((response) => {
              this.fetchUom = response.data.datas.data;
          });
      },


      changeUom(ev){
          this.forms.uom            = ev.codeDesc          
          this.forms.rateBaseCode   = ev.codeId          
      },

      asyncSearchSAPMaterialCode(ev){
          const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/bm-wms-code-cml/get-data";
          return this.$http
          .get(
              baseURI +
              `?limit=20&page=1&&codeType=MAT_COD&codeDesc=${ev}`,
              { timeout: 60000 })
          .then((response) => {
              this.fetchSAPMaterialCode = response.data.datas.data;
          });
      },


      changeSAPMaterialCode(ev){
          this.forms.SAPMaterialCode           = ev.codeId          
      },


      asyncSearchchargeType(ev){
          const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/bm-wms-code-cml/get-data";
          return this.$http
          .get(
              baseURI +
              `?limit=20&page=1&&codeType=CHARGE_TYPE&codeDesc=${ev}`,
              { timeout: 60000 })
          .then((response) => {
              this.fetchchargeType = response.data.datas.data;
          });
      },

      changechargeType(ev){
          this.forms.chargeType           = ev.codeDesc
          this.forms.chargeTypeCode       = ev.codeId
          
      },

      changechargeCategory(ev){
          this.forms.chargeCategory           = ev.codeDesc
          this.forms.chargeCategoryCode       = ev.codeId
          
      },

      asyncSearchchargeCategory(ev){
          const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/bm-wms-code-cml/get-data";
          return this.$http
          .get(
              baseURI +
              `?limit=20&page=1&&codeType=CHARGE_CATEGORY&codeDesc=${ev}`,
              { timeout: 60000 })
          .then((response) => {
              this.fetchchargeCategory = response.data.datas.data;
          });
      },
      
        resetForm() {

        this.fetchitemCategory                 = [];
        this.fetclocCategory                 = [];
        this.locCategory                      = null;
        this.fetchUom                 = [];
        this.Uom                      = null;
        this.fetchchargeType          = [];
        this.chargeType               = null;
        this.fetchSAPMaterialCode     = [];
        this.SAPMaterialCode          = null;
        this.fetchchargeCategory      = [];
        this.chargeCategory           = null;
        this.forms.idRateBase         = ""
        this.forms.rateBaseName=""
        this.forms.chargeCategory=""
        this.forms.chargeCategoryCode=""
        this.forms.chargeType=""
        this.forms.chargeTypeCode=""
        this.forms.SAPMaterialCode=""
        this.forms.SAPDivision=""
        this.forms.queryFormula=""
        this.forms.uom=""
        this.forms.addwho=""
        this.forms.rateBaseDesc=""
        this.forms.editwho=""
        this.forms.adddate=""
        this.forms.editdate=""
        this.forms.rateBaseCode=""
        this.forms.itemCategory=""
        this.forms.locCategory=""
        this.forms.locCategoryCode=""

        },
  
        backForm() {
            window.location.href = "/billing-cml/ratebase";
        },
  
        loadData(id) {
            this.isLoading = true;
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/ratebase/detail/" + id;
            return this.$http.get(baseURI,{ timeout: 60000 }).then((response) => {
            
            this.isLoading      = false;
            this.forms          = response.data.datas;
            this.chargeCategory = {warehouseId:"" , customerId:"" , category:"CHARGE_CATEGORY" , codeId:response.data.datas.chargeCategoryCode ,activeFlag:"",  codeDesc:response.data.datas.chargeCategory};
            this.chargeType     = {warehouseId:"" , customerId:"" , category:"CHARGE_TYPE" , codeId:response.data.datas.chargeTypeCode ,activeFlag:"",  codeDesc:response.data.datas.chargeType};
            this.SAPMaterialCode  = {warehouseId:"" , customerId:"" , category:"MAT_COD" , codeId:response.data.datas.SAPMaterialCode ,activeFlag:"",  codeDesc:response.data.datas.SAPMaterialCode};
            this.Uom            = {warehouseId:"" , customerId:"" , category:"RAT_BAS" , codeId:response.data.datas.rateBaseCode ,activeFlag:"",  codeDesc:response.data.datas.uom};
            this.locCategory    = {warehouseId:"" , customerId:"" , category:"LOC_CAT" , codeId:response.data.datas.locCategoryCode ,activeFlag:"",  codeDesc:response.data.datas.locCategory};

            }).catch(error => {
            this.loading();
                    
            
                if(error.code == "ECONNABORTED"){
                  this.error(this.$t("check_internet_connection_txt"));
                  
                }else{
  
                    if (error.response) {
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        }else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        }else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        }else{
                            this.$router.push('/page-not-found');
                        }
                    }
  
                }
    
            });
        },
  
        fetchIt() {
            const userDatas     = this.$getUserInfo();
            this.userData       = userDatas.sub;
            this.userRole       = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function(permision){
            if(permision.permission.controller == 'RatebaseCmlController'){
                rolePermision = permision;
                // console.log(permision);
            }
            });
    
            if(!rolePermision.method_update){
            this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;
    
        },
  
        submitData() {
            this.fade(true);
                this.isLoading = true;
    
                const baseURI =
                this.$settings.endPointBilling + "dashboard/cml-billing/ratebase/update/" + this.forms.idRateBase;
                this.$http
                .patch(baseURI, this.forms,{ timeout: 60000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                    //this.resetForm();
                    this.errors = [];
                    this.success(response.data.datas.messages);
    
                    //window.history.back();
                    var params = this.$onRandom(this.forms.idRateBase);
                    window.location.href = "/billing-cml/ratebase/detail/" + params + "?status=200&msg=Successfully";
                    } else {
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                    }
                })
                .catch((error) => {
                    this.loading();
                    this.isLoading = false;
                    
                    if(error.code == "ECONNABORTED"){
                      this.error(this.$t("check_internet_connection_txt"));
                      
                    }else{
      
                        if (error.response) {
                            if(error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            }else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            }else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            }else{
                                this.$router.push('/page-not-found');
                            }
                        }
      
                    }
                    //this.resetForm();
                });
        },
  

        logout(){

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
                
            console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },
        
        fade(sType) {
            this.isLoading = sType;
        },
  
        loading() {
            this.fade(true);
            setTimeout(() => {
            this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },
  
        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
            var nameOb = Object.keys(data)[x];
            var objectData = data[nameOb];
            for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
            }
            }
        },
  
        success(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            // onShown: function() {
            //     console.log('asdasdasd');
            //     //window.location.href = '/';
            // }
            });
    
            Toast.fire({
            icon: "success",
            title: kata,
            });
        },
  
        error(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "error",
            title: kata,
            });
        },

    },
    events: {},
    created: function () {},
    mounted() {
      var params = this.$onBehind(this.$route.params.id);
      this.loadData(params[0]);
      this.fetchIt();
    },
  };
  </script>
  <style scoped>
   
  </style>